<route-meta>
{
  "requiresAuth": true
}
</route-meta>

<template>
  <div class="extension__create">
    <h1>{{ $t('general.createWhat', { what: entity }) }}</h1>

    <div class="extension__form">
      <extension-form
        :fields="fields"
        :object="object"
        @structure="setObjectStructure"
      ></extension-form>
      <div class="extension__form__submit">
        <button
          @click="save"
          class="btn btn--save"
        >
          {{ $t('general.save') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ExtensionForm from './form';
import Field from '@/components/Field';
import { mapGetters } from 'vuex';

export default {
  name: 'forms-create',
  components: {
    Field,
    ExtensionForm,
  },
  computed: {
    ...mapGetters('forms', {
      fields: 'getFields',
    }),
    editName() {
      return `${this.entity}-id`;
    },
  },
  data() {
    return {
      object: {},
      entity: 'forms',
    };
  },
  methods: {
    setObjectStructure(value) {
      const object = JSON.parse(JSON.stringify(this.object));
      object.structure = value;
      this.object = object;
    },
    save() {
      this.$store.dispatch(`${this.entity}/add`, {
        object: this.object,
        callback: data => {
          this.$router.push({ name: this.editName, params: { id: data._id } });
          this.$success(this.$t('general.messages.create.success'));
        },
      });
    },
  },
};
</script>
